import type { OpeningWindow } from "@bytebite/schemas";

export const WEEKDAY_LABELS = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
] as const;

export type DayWindows = {
  weekday: number;
  windows: { opensAt: string; closesAt: string }[];
};

export function emptyWeekDraft(): DayWindows[] {
  return WEEKDAY_LABELS.map((_, weekday) => ({ weekday, windows: [] }));
}

export function hoursToDraft(windows: readonly OpeningWindow[]): DayWindows[] {
  const draft = emptyWeekDraft();
  for (const window of windows) {
    const day = draft[window.weekday];
    if (!day) continue;
    day.windows.push({ opensAt: window.opensAt, closesAt: window.closesAt });
  }
  return draft;
}

export function draftToWindows(draft: readonly DayWindows[]): OpeningWindow[] {
  return draft.flatMap((day) =>
    day.windows
      .map((window) => ({
        weekday: day.weekday,
        opensAt: normalizeClockInput(window.opensAt),
        closesAt: normalizeClockInput(window.closesAt),
      }))
      .filter((window) => window.opensAt.length > 0 || window.closesAt.length > 0),
  );
}

export function normalizeClockInput(value: string): string {
  const match = /^(\d{1,2}):(\d{2})/.exec(value.trim());
  if (!match) return value.trim();
  const hours = Number(match[1]);
  const minutes = match[2];
  if (!Number.isInteger(hours) || hours < 0 || hours > 23) return value.trim();
  return `${String(hours).padStart(2, "0")}:${minutes}`;
}

export function formatWindowsLine(windows: readonly { opensAt: string; closesAt: string }[]): string {
  return windows.map((window) => `${window.opensAt}–${window.closesAt}`).join(", ");
}
